<template>
  <Dialog v-bind="attrs">
    <template #content>
      <v-alert
        :color="alertColor"
        variant="outlined"
        density="compact"
        class="premium-alert"
      >
        <slot />
      </v-alert>
    </template>

    <template #footer>
      <div class="dialog-footer">
        <v-btn
          class="btn-danger"
          @click="emit('on-cancel')"
        >
          <v-icon class="mr-2">mdi-close</v-icon>Não
        </v-btn>

        <v-btn
          class="btn-primary"
          @click="onSubmit"
          :disabled="disableButton"
        >
          <v-icon class="mr-2">mdi-check</v-icon>Sim
        </v-btn>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { ref, computed, useAttrs } from 'vue'
import Dialog from '@/components/ui/Dialog.vue'

defineOptions({ name: 'uiDialogConfirmation' })

const props = defineProps({
  type: { type: String, default: 'info' },
})

const emit = defineEmits(['on-submit', 'on-cancel'])
const attrs = useAttrs()

const disableButton = ref(false)
const alertColor = computed(() => {
  const t = (props.type || '').toLowerCase()
  return ['success', 'info', 'warning', 'error'].includes(t) ? t : 'info'
})

function onSubmit () {
  disableButton.value = true
  emit('on-submit')
}
</script>

<style scoped>
/* Alerta premium */
.premium-alert {
  border-radius: 12px;
  padding: 16px;
  font-weight: 500;
  text-align: center;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(245, 246, 250, 0.95) 100%
  );
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

/* Footer alinhado */
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 12px;
}

/* Botão primário */
.btn-primary {
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: #fff !important;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.35);
  transition: all 0.2s ease-in-out;
}
.btn-primary:hover {
  background: linear-gradient(135deg, #1d4ed8, #2563eb);
  transform: translateY(-2px);
}

/* Botão danger */
.btn-danger {
  background: linear-gradient(135deg, #dc2626, #ef4444);
  color: #fff !important;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(220, 38, 38, 0.35);
  transition: all 0.2s ease-in-out;
}
.btn-danger:hover {
  background: linear-gradient(135deg, #b91c1c, #dc2626);
  transform: translateY(-2px);
}

/* Disabled */
.btn-primary:disabled,
.btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}
</style>
